import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'

export default {
  getVolunteers(payload) {
    return http.get(endpoints.get('getVolunteers', { wioStructLocationId: payload }))
  },
  assignVolunteer(payload) {
    return http.post(endpoints.get('assignVolunteer', { ...payload }), {
      volunteer_id: payload.volunteerId
    })
  },
  detachVolunteer(payload) {
    return http.post(endpoints.get('detachVolunteer', { childEditionId: payload }))
  }
}
